<template>

  <div ref="loadableModeration"
    class="moderation-wrapper table-wrapper scrollable moderation-table"
    :class="name+'-table'"
  >
    <!--<div class="pagination-posts previous-post" v-if="!pins && gridData.paging && gridData.paging.previous">
      <vs-button class="page-btn btn-large" @click="paginationPosts('previous')">
        {{ $t("dash.moderation.previous-posts")}}
      </vs-button>
    </div>-->
    <div class="moderation-content" ref="loadableModerationContent">
      <ul id="moderation-content" class="moderation-body scrollable"  v-if="badWordsFeed">
        <li class="row post" 
          v-for="(item, key) in gridData.data" 
          :key="key" 
          :class="`comment-${key}`" 
        >
          <comments-post 
            :page="item.page" 
            :post="item" 
            :key="`comments-${key}`"
            :badWordsFeed="badWordsFeed"
            :badWordList="badWordList"
            v-on:getPosts="getPosts"
            v-on:addPostLike="addPostLike"
            v-on:badWordsDetected="badWordsDetected"
            v-on:deleteCommentWithBadWord="deleteCommentWithBadWord"
          ></comments-post>
        </li>
      </ul>
      <ul id="moderation-content" class="moderation-body scrollable" v-else>
        <li class="row post" 
          v-for="(item, key) in gridData.data" 
          :key="key" 
          :class="`post-${key}`" 
          v-observe-visibility="{
              callback: visibilityChanged,
              once: true,
            }"
          >
          <div :id="`content-post-${key}`" class="content-post" v-if="key <= numMaxPostLoaded">
            <vs-button v-if="!pins && checkPins(item)" @click="addPin(item)" class="btn-drop pin add" type="filled"> 
              <Tooltip
                :text="$t('dash.moderation.pins.add')"
                position="top"
              >
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"/></g><g><path d="M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z" fill-rule="evenodd"/></g></svg>
              </Tooltip>
            </vs-button>
            
            <vs-button v-if="pins || !checkPins(item)" @click="removePin(item)" class="btn-drop pin remove" type="filled">
              <Tooltip
                :text="$t('dash.moderation.pins.remove')"
                position="top"
              >
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"/></g><g><path d="M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z" fill-rule="evenodd"/></g></svg>
              </Tooltip>
            </vs-button>
            <preview-post 
              :page="gridData.pages" 
              :post="convertToPreview(item)" 
              :moderation="true" 
              :key="`post-${item.id}`"
            ></preview-post>
            <comments-post 
              :page="gridData.pages" 
              :post="item" 
              :key="`comments-${item.id}`"
              :badWordList="badWordList"
              v-on:switchComment="switchComment"
              v-on:getPosts="getPosts"
              v-on:addPostLike="addPostLike"
              v-on:badWordsDetected="badWordsDetected"
              v-on:addCountComments="addCountComments"
            ></comments-post>
          </div>
          <div :id="`content-post-${key}`" class="content-post lazyload" v-else></div>
        </li>
      </ul>
    </div>
    <!--<div class="pagination-posts next-post" v-if="!pins && gridData.paging && gridData.paging.next">
      <vs-button class="page-btn btn-large" @click="paginationPosts('next')" vs-type="filled">
        {{ $t("dash.moderation.next-posts")}}
      </vs-button>
    </div>-->
  </div> 
</template>

<script>
import moment from 'moment'
import PreviewPost from './PreviewPost.vue'
import CommentsPost from './CommentsPost.vue'
import ClickOutside from 'vue-click-outside'
import Bots from './../mixins/Bots'
import Posts from './../mixins/Posts'
import Moderation from './../mixins/Moderation'
import { ObserveVisibility } from 'vue-observe-visibility'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  name: 'component-posts-feed',

  mixins: [Moderation],

  components: {
    PreviewPost,
    CommentsPost,
    Tooltip
  },

  directives: {
    ClickOutside,
    ObserveVisibility
  },

  props: {
    gridData: Object,
    name: {
      type: String,
      required: true
    },
    pins: Boolean,
    activeBadWordsDetection: Boolean,
    badWordsFeed: Boolean,
    badWordList: Array
  },

  data() {
    return {
      showSidebar: false,
      post: {
        id: null,
        created_time: null,
        full_picture: null,
        link: null,
        message: null,
        permalink_url: null
      },
      comments: null,
      bots: null,
      posts: [],
      numMaxPostLoaded: 0
    }
  },

  mounted() {
    //console.log('pageId', this.gridData.pages.id)
    //this.bots = JSON.parse(localStorage.bots).filter(b => b.page.id == this.gridData.pages.id)
    //console.log('this.bots', this.bots)
   // this.initDaysWeekTab(this.startDate)
  },

   

  methods: {
    addCountComments(countComments){
      this.$emit('addCountComments', countComments)
    },

    deleteCommentWithBadWord(commentid){
      this.$emit('deleteCommentWithBadWord', commentid)
    },

    badWordsDetected(post, comment, badWords){
      this.$emit('badWordsDetected', post, comment, badWords)
    },

   /* paginationPosts(type='next') {
      this.numMaxPostLoaded = 0
      this.$emit('paginationPosts', type)
    },*/

    visibilityChanged (isVisible, entry) {
        //this.isVisible = isVisible
      if(isVisible){
        let idPost = parseInt(entry.target.classList[2].replace('post-', ''))
        if(idPost > this.numMaxPostLoaded)
          this.numMaxPostLoaded = idPost
      }
    },

    convertToPreview(item){
      if(item.id) {
        let post = {}
        post.id = item.id
        if(item.followers)
        post.followers = item.followers
        if(item.content)
        post.content = item.content
        if(item.meta)
        post.meta = item.meta
        post.is_comment_enabled = item.is_comment_enabled
        // post.title = this.urlify(item.message)
        post.title = item.message
        if(item.content)
        post.content = item.content
        if(item.meta)
        post.meta = item.meta
        if(item.link && !item.link.startsWith("https://www.facebook.com"))
          post.url = item.link
        else if(item.full_picture){
          post.page = []
          post.page[0] = {}
          post.page[0].enclosure = item.full_picture
        }
        post.date = item.created_time
        return post
      }
    },

    urlify(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text ? text.replace(urlRegex, '<a href="$1">$1</a>') : ""
    },

    hidePost(commentid){
      this.$emit('hidePost', commentid)
    },

    getPosts(){
      this.$emit('getPosts')
    },

    addPostLike(nodeId){
      this.$emit('addPostLike', nodeId)
    },
    async switchComment(postid,postis_comment_enable){
      console.log('dans switchcomment postfeed',postid,postis_comment_enable)
      //await this.switchComments(this.pagesActive[this.selectedTab], postid, postis_comment_enable)
      this.$emit('switchComment', postid, postis_comment_enable)
    },

    checkPins(node){
      /*if(localStorage.pins){
        let pins = JSON.parse(localStorage.pins)
        if(!pins) return false
        else if(pins.findIndex(post => post.id == node.id)) return true
        return false
      }
      else
        return true*/

        
      if(this.localStoragePins && this.localStoragePins.length){
        if(this.localStoragePins.findIndex(post => post.id == node.id)) return true
        return false
      }
      else
        return true
    },

    addPin(node){
      this.$emit('addPin', node)
    },

    removePin(node){
      this.$emit('removePin', node)
    },

    incNumMaxPostLoaded(){
      this.numMaxPostLoaded++
    },
    
    autoIncNumMaxPostLoaded(){
      for(let i = this.numMaxPostLoaded; i < this.gridData.data.length; i++)
        setTimeout(this.incNumMaxPostLoaded, i*250)
    }

  },

  computed: {
    localStoragePins() {
      if(localStorage.pins)
        return JSON.parse(localStorage.pins)
      else {
        []
      }
    }
  },

  watch: {
    activeBadWordsDetection(){
      if(this.activeBadWordsDetection){
        /*for(let i = this.numMaxPostLoaded; i < this.gridData.data.length; i++)
          setTimeout(this.incNumMaxPostLoaded, i*250)*/
        this.autoIncNumMaxPostLoaded()
      }
    },

    gridData() {
      this.numMaxPostLoaded = 0
      if(this.activeBadWordsDetection) {
        this.autoIncNumMaxPostLoaded()
      }
    }
    

  }

}    
</script>